/* eslint-disable boundaries/dependencies */
import { configureStore } from '@reduxjs/toolkit'

import { modalsReducer } from '@entities/modal'
import { pagesDataReducer } from '@entities/pagesData'

import { reducer as auth } from './_auth'
import { reducer as loader } from './_loader'

const reducer = {
  auth,
  loader,
  pagesData: pagesDataReducer,
  modals: modalsReducer,
}

export const storeModel = configureStore({
  reducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
  devTools: process.env.NODE_ENV !== 'production',
})
